/**
 * VOP reservation status labels — indexed by the integer status code (0–14).
 *
 * Statuses outside this range are handled inline at call sites:
 *   20 → 'Réservation annulée'  (API value)
 *   21 → overdue, injected client-side in reservation-list
 */
export const RESERVATION_STATUS_NAMES: string[] = [
    `À venir`,                                                                  // 0
    `À venir (mis à jour)`,                                                     // 1
    `À venir (état des lieux disponible)`,                                      // 2
    `En cours (état des lieux d'entrée sans prise de photo)`,                   // 3
    `En cours (état des lieux d'entrée avec prise de photo)`,                   // 4
    `En cours (première ouverture de porte effectué)`,                          // 5
    `En cours (prolongation de réservation)`,                                   // 6
    `En cours (sinistre déclaré)`,                                              // 7
    `En cours (alerte détecté)`,                                                // 8
    `En attente de clôturation (état des lieux de sortie sans prise de photo)`, // 9
    `En attente de clôturation (état des lieux de sortie avec prise de photo)`, // 10
    `Clôturée`,                                                                 // 11
    `Clôturée (en attente de facturation)`,                                     // 12
    `Clôturée (facturé)`,                                                       // 13
    `Clôturée (client prélevé)`,                                                // 14
];
